<div class="page-content">
    <div class="content-header">
        <div class="title">
            <span class="large-screen-content">CHECK GIFT CARD BALANCE</span>
            <span class="small-screen-content">CHECK BALANCE</span>
        </div>
        <div class="actions">
            <span class="large-screen-content">
                To purchase a gift card, click
                <a
                    class="back-link"
                    color="primary"
                    (click)="goToPurchaseGiftCardPage()"
                    >here</a
                >.</span
            >
            <a
                class="back-link small-screen-content"
                color="primary"
                (click)="goToPurchaseGiftCardPage()"
                >Purchase Gift Card</a
            >
        </div>
    </div>
    <div
        class="content-body"
        skeletonScreen
        [showSkeleton]="!details?.id?.length"
        [placeholderHeight]="'20px'"
    >
        <mat-card>
            <mat-card-title>Details</mat-card-title>
            <mat-card-subtitle skeletonData>
                Gift Card ID:
                {{ details?.id | giftCardID }}
            </mat-card-subtitle>
            <mat-card-subtitle skeletonData>
                Current Balance:
                <strong qa="gift-card-balance">{{
                    details?.balance | dsiCurrency
                }}</strong>
            </mat-card-subtitle>
            <mat-card-content>
                <div class="gift-card-table-container">
                    <table
                        skeletonTable
                        [skeletonTableRowAmount]="5"
                        mat-table
                        [dataSource]="details?.transactionList"
                    >
                        <ng-container matColumnDef="date">
                            <th mat-header-cell *matHeaderCellDef>Date</th>
                            <td mat-cell *matCellDef="let transaction">
                                {{ transaction.date }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>Action</th>
                            <td mat-cell *matCellDef="let transaction">
                                {{ transaction.action }}
                                {{ transaction.amount | dsiCurrency }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="amount">
                            <th mat-header-cell *matHeaderCellDef>Amount</th>
                            <td mat-cell *matCellDef="let transaction">
                                {{ transaction.amount | dsiCurrency }}
                            </td>
                        </ng-container>
                        <tr
                            mat-header-row
                            *matHeaderRowDef="transactionTableHeaders"
                        ></tr>
                        <tr
                            mat-row
                            *matRowDef="
                                let row;
                                columns: transactionTableHeaders
                            "
                        ></tr>
                    </table>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="content-footer">
        <button
            mat-stroked-button
            class="ols-mat-stroked-button-color"
            color="primary"
            (click)="goToCheckAnotherBalance()"
            qa="close-balance-giftcard"
        >
            Check Another Balance
        </button>
    </div>
</div>
